module.exports = __webpack_public_path__ + "static/media/new-room.4580f3a4.png";